import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const colorPaletteTool: Tool = {
  id: "color-palette",
  name: () => m.cp_tool_name(),
  description: () => m.cp_tool_description(),
  icon: "🎨",
  basePath: "/color-palette",
  status: "stable",
  tags: ["design", "color", "palette", "color-palette"],
};
